import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { TREE_TYPE } from 'editor-utils/template';
import TreeTypeCard from './treeTypeCard';

const TREE_TYPE_PROPS = {
  [TREE_TYPE.SINGLE]: {
    name: 'STANDARD',
    description: 'Follows the family tree of a single person back four to seven generations.',
    icon: '/static/img/poster-standard.png?_',
  },
  [TREE_TYPE.COMBO]: {
    name: 'COMBINATION',
    description: 'Follows each side of the family back three or four generations.',
    icon: '/static/img/poster-combination.png?_',
  },
  [TREE_TYPE.DESC]: {
    name: 'DESCENDANT',
    description:
      'This book records the line of one individual forward for three or four generations.',
    icon: '/static/img/poster-descendant.png?_',
  },
};

const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: -5px;
  padding-right: -5px;
`;

const GridItem = styled.div`
  flex: 0 0 ${100 / 3}%;
  max-width: ${100 / 3}%;
  padding-left: 5px;
  padding-right: 5px;
`;

const TreeTypeSelect = ({ onChange, treeTypes, selectedTreeType }) => {
  return (
    <Grid>
      {treeTypes.map(treeType => (
        <GridItem key={treeType}>
          <TreeTypeCard
            type={treeType}
            {...TREE_TYPE_PROPS[treeType]}
            isSelected={selectedTreeType === treeType}
            onSelect={onChange}
          />
        </GridItem>
      ))}
    </Grid>
  );
};

TreeTypeSelect.defaultProps = {
  onChange: () => {},
  treeTypes: [],
  selectedTreeType: undefined,
};

TreeTypeSelect.propTypes = {
  onChange: PropTypes.func,
  treeTypes: PropTypes.arrayOf(PropTypes.string),
  selectedTreeType: PropTypes.string,
};

export default TreeTypeSelect;
